import styled from '@emotion/styled';
import { colors, sizes } from '@smartsheet/lodestar-core';
import { NODE_HEIGHT, NODE_WIDTH } from '../../../../../utils/dimensions';

interface NodeProps {
  selected: boolean;
}

export const Node = styled.div<NodeProps>`
  background: ${colors.neutralLight40};
  outline: ${props => (props.selected ? '2px solid #3576BA' : '0')};
  border-radius: 4px;
  box-sizing: border-box;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.16);
  display: flex;
  width: ${NODE_WIDTH}px;
  height: ${NODE_HEIGHT}px;
  line-height: ${NODE_HEIGHT}px;
  align-items: center;
  padding-right: ${sizes.xSmall}px;

  &:hover {
    outline: 2px solid #3576ba;
    font-weight: bold;
  }
`;
